import React from 'react'


const Loader = () => {

    return (
        <>
            <div class="loading-overlay is-active">
                <div class="loading">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </div>
        </>
    )
}

export default Loader;